import useHttp from './use-http';

// @ts-ignore
const useConversions = () => {
    const convertDate = (date) => {
        if (!date) {
            return null;
        }

        return new Date(date).toISOString();
    };

    const getConversions = (contactId, startDate = null, endDate = null, page = null) => {
        const url = `/api/v1/contacts/${contactId}/conversions`;

        const { http } = useHttp();
        return http.get(url, {
            params: {
                page,
                start_date: convertDate(startDate),
                end_date: convertDate(endDate)
            }
        });
    };

    const getConversionsTotal = (contactId, startDate = null, endDate = null) => {
        const url = `/api/v1/contacts/${contactId}/conversions/total`;

        const { http } = useHttp();
        return http.get(url, {
            params: {
                start_date: convertDate(startDate),
                end_date: convertDate(endDate)
            }
        });
    };

    return {
        getConversions,
        getConversionsTotal
    };
};

export default useConversions;
